import React, { useState } from 'react'
import { redirectTo, concatParamsToUrl } from 'src/utils/Http';
import * as Urls from 'src/constants/EndpointUrls';
import _ from 'lodash'
import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';
import { useTranslation } from 'react-i18next'

export default function Step2Modal({ cookie }) {
  const [onOpenModal, setOnOpenModal] = useState(true)
  const setOnCloseModal = () => setOnOpenModal(false)
  const { t } = useTranslation()
  const { run, type, stepIndex, params } = cookie
  const editUrl = (url, formatId) => concatParamsToUrl(url, { ...formatId });

  const onConfirm = () => {
    if (cookie && run) {
      if (run && (type == 'create')) {
        if (stepIndex == 1) {
          redirectTo(Urls.CLIENT_PAYROLL_RULES_GROUP_LIST)
        }
        else if (stepIndex > 1) {
          redirectTo(Urls.CLIENT_PAYROLL_RULES_GROUP_NEW)
        }
      }
      else if (run && (type == 'check')) {
        if (_.inRange(stepIndex, 2)) { // 0, 1
          redirectTo(Urls.CLIENT_PAYROLL_RULES_GROUP_LIST)
        }
        else if (stepIndex == 2) {
          redirectTo(editUrl(Urls.CLIENT_ALLOWANCES_LIST, params))
        }
        else if (_.inRange(stepIndex, 3, 5)) { // 3, 4
          redirectTo(editUrl(Urls.CLIENT_UNIT_PRICES_LIST, params))
        }
        else if (_.inRange(stepIndex, 5, 9)) { //5, 6, 7, 8
          redirectTo(editUrl(Urls.CLIENT_UNIT_PRICE_EDIT, params))
        }
        else if (stepIndex == 9) {
          redirectTo(editUrl(Urls.CLIENT_UNIT_PRICES_LIST, params))
        }
        else if (_.inRange(stepIndex, 10, 12)) { // 10, 11
          redirectTo(editUrl(Urls.CLIENT_ALLOWANCES_LIST, params))
        }
        else if (_.inRange(stepIndex, 12, 14)) { // 12, 13
          redirectTo(editUrl(Urls.CLIENT_ALLOWANCE_EDIT, params))
        }
      }
    }
  }
  return (
    <CommonModal hideModal={setOnCloseModal} isOpen={onOpenModal} ariaHideApp={false}>
      <CommonModal.Header hideModal={setOnCloseModal}>{t('features.GuideTour.Modal.Title')}</CommonModal.Header>
      <CommonModal.Body>{t('features.GuideTour.Modal.ContinueWorkingTutorial')} </CommonModal.Body>
      <CommonModal.Footer>
        <CommonModal.Buttons>
          <Button onClick={setOnCloseModal}>{t('features.GuideTour.Button.close')}</Button>
          <Button primary onClick={onConfirm}>{t('features.GuideTour.Button.next')}</Button>
        </CommonModal.Buttons>
      </CommonModal.Footer>
    </CommonModal>
  )
}
